export default "__VITE_ASSET__c8645963__"